import script from "./InstructionKeepinPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionKeepinPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionKeepinPage.vue?vue&type=style&index=0&id=02d4e355&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02d4e355"]])

export default __exports__